module.exports = __webpack_public_path__ + "img/brand2.47f0565b.png";